import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import isTomorrow from 'dayjs/plugin/isTomorrow';
import utc from 'dayjs/plugin/utc';

dayjs.extend(calendar);
dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(isTomorrow);
dayjs.extend(utc);

export const calendarDate = (date: string) =>
  dayjs(date).calendar(null, {
    sameDay: `[Today ]`,
    nextDay: `[Tomorrow ]`,
    nextWeek: `dddd`,
    sameElse: 'MMM Do',
    lastDay: '[Yesterday ]',
    lastWeek: '[Last] dddd',
  });

export enum DayjsFormat {
  /** 10/16/2025 */
  DATE = 'MM/DD/YYYY',
  /** 2025-10-16 */
  CALENDAR_DATE = 'YYYY-MM-DD',
  /** 8:45 pm */
  TIME_12H_LOWER = 'h:mm a',
  /** 8:45 PM */
  TIME_12H_UPPER = 'h:mm A',
  /** 20:45 */
  TIME_24H = 'HH:mm',
  /** 8:45:30 pm */
  TIME_12H_WITH_SECONDS = 'h:mm:ss a',
  /** 10/16/2025 8:45 pm */
  DATE_TIME_12H_LOWER = 'MM/DD/YYYY h:mm a',
  /** 10/16/2025 8:45 PM */
  DATE_TIME_12H_UPPER = 'MM/DD/YYYY h:mm A',
  /** 10/16/2025 20:45 */
  DATE_TIME_24H = 'MM/DD/YYYY HH:mm',
  /** October 16, 2025 */
  LONG_DATE = 'MMMM D, YYYY',
  /** October 16, 2025 8:45 PM */
  LONG_DATE_TIME_12H = 'MMMM D, YYYY h:mm A',
  /** October 16, 2025 at 8:45 PM */
  LONG_DATE_TIME__WITH_AT_12H = 'MMMM D, YYYY [at] h:mm A',
  /** 8:45 pm */
  HHmma = 'hh:mma',
  /** Friday, January 6 */
  LONG_DATE_WITH_DAY = 'dddd, MMMM D',
  /** January 6 */
  SHORT_DATE = 'MMMM D',
  /** Jan 6, 2026 */
  SHORT_DATE_WITH_YEAR = 'MMM D, YYYY',
}

export const formatDate = (date: string, format = DayjsFormat.DATE) => {
  return dayjs(date).format(format);
};

export const formatDateWithDay = (dateString: string, format = DayjsFormat.DATE): string => {
  const date = dayjs(dateString);

  if (date.isToday()) {
    return `Today • ${date.format(format)}`;
  }

  if (date.isYesterday()) {
    return `Yesterday • ${date.format(format)}`;
  }
  if (date.isTomorrow()) {
    return `Tomorrow • ${date.format(format)}`;
  }
  return date.format(format);
};

export const calendarFormatDateWithDay = (
  dateString: string,
  format = DayjsFormat.LONG_DATE_WITH_DAY
): string => {
  const date = dayjs(dateString);

  if (date.isToday()) {
    return `Today - ${date.format(format)}`;
  }

  if (date.isYesterday()) {
    return `Yesterday - ${date.format(format)}`;
  }
  if (date.isTomorrow()) {
    return `Tomorrow - ${date.format(format)}`;
  }
  return date.format(format);
};
